var sessionStorageManager = require('store2').session
var localStorageManager = require('store2')

var getSessionData = (key) => {
  return sessionStorageManager.get(key)
}

var saveSessionData = (key, value) => {
  sessionStorageManager.set(key, value)
}

var clearSessionData = (key) => {
  return sessionStorageManager.remove(key)
}

var getLocalData = (key) => {
  return localStorageManager.get(key)
}

var saveLocalData = (key, value) => {
  localStorageManager.set(key, value)
}

var clearLocalData = (key) => {
  return localStorageManager.remove(key)
}

export const Storage = {
  Get: getSessionData,
  Save: saveSessionData,
  Clear: clearSessionData,
  GetLocal: getLocalData,
  SaveLocal: saveLocalData,
  ClearLocal: clearLocalData,
  GetSession: getSessionData,
  SaveSession: saveSessionData,
  ClearSession: clearSessionData
}

export const StorageKeys = {
  ConfirmAbandonChanges: 'confirmAbandonChanges'
}

export default Storage
